const projects = [
  {
    title: "QRescue – Emergency QR System",
    description:
      "A React-based application that generates emergency QR stickers for helmets, allowing first responders to access vital health data instantly.",
    tech: ["React", "Bootstrap", "Framer Motion", "Node.js"],
    link: "https://qrescue.gr"
  },
  {
    title: "Mads - Electric Scooters",
    description:
      "A web application for buying electric scooters, featuring a user-friendly interface and a robust backend for managing orders and inventory.",
    tech: ["WordPress", "WooCommerce", "PHP", "MySQL"],
    link: "https://mads.gr"
  },
  {
    title: "GreekHumans",
    description:
      "Maintenance and development of a web application for the GreekHumans community, focusing on user engagement and content management.",
    tech: ["WordPress", "PHP", "MySQL"],
    link: "https://greekhumans.com"
  },
  {
    title: "NutritionGoals",
    description:
      "Development of a web application for the NutritionGoals, helping a nutritionist grow their online presence with a clear, accessible site highlighting services and expertise.",
    tech: ["WordPress", "PHP", "MySQL"],
    link: "https://nutritiongoals.gr"
  },

  {
    title: "Internal Web App for Order Management",
    description:
      "Developed a custom web-based platform in React + Express for handling internal order requests with real-time tracking and status updates.",
    tech: ["React", "Node.js", "Express", "MongoDB"],
    
  }
];

export default projects;
